export enum PLAN_TYPE {
    DEFAULT = 'DEFAULT',
    COVERAGE = 'COVERAGE',
}

export enum BILLING_METHOD {
    SHOPIFY = 'SHOPIFY',
    STRIPE = 'STRIPE',
}

export enum ONBOARDING_STEPS {
    NEW_USER_WELCOME = 'NEW_USER_WELCOME',
    ACCEPT_TERMS = 'ACCEPT_TERMS',
    CHOOSE_PLAN_TYPE = 'CHOOSE_PLAN_TYPE',
    CHOOSE_PLAN = 'CHOOSE_PLAN',
    CHOOSE_RETURN_TYPE = 'CHOOSE_RETURN_TYPE',
    CREATE_RETURN_METHOD = 'CREATE_RETURN_METHOD',
    WALLET_CONFIGURATION = 'WALLET_CONFIGURATION',
    ENABLE_RETURN_GUARD = 'ENABLE_RETURN_GUARD',
    SETUP_RETURN_GUARD = 'SETUP_RETURN_GUARD',
    APPROVE_PLAN = 'APPROVE_PLAN',
    FINAL = 'FINAL',
}

export enum RETURN_LOCATION_TAB {
    PLATFORM = "PLATFORM",
    CUSTOM_ADDRESS = "CUSTOM_ADDRESS",
}

export enum RESTOCK_LOCATION_TAB {
    PLATFORM = "PLATFORM",
    FULFILLMENT_LOCATION = "FULFILLMENT_LOCATION",
}